module.exports = __webpack_public_path__ + "static/media/leicester.7e529cbc.png";